var map = {
	"./bg.png": "3f6e",
	"./errorPage/bg.jpg": "29a8",
	"./errorPage/card1.png": "50e3",
	"./errorPage/code.png": "cc8c",
	"./errorPage/gift.png": "edd0",
	"./errorPage/logo.png": "f30c",
	"./errorPage/logo1.jpg": "f331",
	"./errorPage/logo2.jpg": "11f2",
	"./errorPage/person.png": "962a",
	"./errorPage/write.png": "9b9f",
	"./errorPage/图片2.png": "3a18",
	"./friend.png": "36d7",
	"./friendGray.png": "1ac8",
	"./logo-zc.jpg": "4d67",
	"./logo.png": "9d64",
	"./logo1.png": "b189",
	"./project.png": "807b",
	"./projectGray.png": "7430",
	"./rmb.png": "f3bb",
	"./shareArrow.png": "35fe",
	"./shareArrow2.png": "8683"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";